/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramCategoryControllerGetMetaTreeQueryResponse,
  TelegramCategoryControllerGetMetaTreeQueryParams,
} from '../types/TelegramCategoryControllerGetMetaTree.ts';

function getTelegramCategoryGetMetaTreeUrl() {
  const res = { method: 'GET', url: `/api/telegram/category/meta-tree` as const };
  return res;
}

/**
 * {@link /api/telegram/category/meta-tree}
 */
export async function telegramCategoryGetMetaTree(
  params?: TelegramCategoryControllerGetMetaTreeQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramCategoryControllerGetMetaTreeQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramCategoryGetMetaTreeUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
